// Return destinations are generated by the authenticated API from the
// first-party app registry. This browser check is deliberately only a shape
// guard for that response: it has no origin allowlist and must never be used for
// query-string or browser-storage values.

const MAX_RETURN_URL_LENGTH = 2048;

export function apiReturnUrl(value: string | null | undefined): string | null {
  if (!value || value.length > MAX_RETURN_URL_LENGTH) return null;
  try {
    const parsed = new URL(value);
    if (parsed.username || parsed.password || parsed.hostname.endsWith(".")) return null;
    if (parsed.protocol === "https:") return value;
    if (
      parsed.protocol === "http:" &&
      (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1")
    ) {
      return value;
    }
  } catch {
    // Malformed API data is treated as if the optional return were absent.
  }
  return null;
}
